import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const HistoryItem = ({ data, index }) => {
  const navigate = useNavigate();
  const handleView = () => {
    navigate(`/client/result/${data._id}`);
  };

  const updatedAt = new Date(data.updatedAt);
  const date = moment(updatedAt).format("MMM Do YY");

  return (
    <tr className="border-b">
      <td className="px-2 py-4 overflow-clip">
        <span>{index + 1}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>
          {data.examDetails?.topicName ||
            `Dynamic (${data.dynamicExamDetails?.topicName})`}
        </span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{date}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>
          {data.points}/{data.maxPoints}
        </span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        {Math.ceil((data.points / data.maxPoints) * 100) >= 50 ? (
          <span className="text-green-600 font-medium">Pass</span>
        ) : (
          <span className="text-red-500 font-medium">Fail</span>
        )}
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{data.attemptCount}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <button onClick={handleView} className="border-b-2 border-secondary">
          View
        </button>
      </td>
    </tr>
  );
};

export default HistoryItem;
